var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCoupon38X38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.625 16.625A2.372 2.372 0 0 0 33.25 19a2.372 2.372 0 0 0 2.375 2.375v5.542a3.176 3.176 0 0 1-3.167 3.166H5.542a3.176 3.176 0 0 1-3.167-3.166v-5.542A2.372 2.372 0 0 0 4.75 19a2.372 2.372 0 0 0-2.375-2.375v-5.542a3.176 3.176 0 0 1 3.167-3.166h26.916a3.176 3.176 0 0 1 3.167 3.166v5.542Zm-18.747-1.852a2.106 2.106 0 1 1-4.211 0 2.106 2.106 0 0 1 4.211 0Zm6.35 10.544a2.106 2.106 0 1 0 0-4.211 2.106 2.106 0 0 0 0 4.211Zm-10.102-.459a.743.743 0 0 0 .554.238h.016c.19 0 .396-.08.554-.238l10.624-10.624a.784.784 0 0 0 0-1.124.784.784 0 0 0-1.124 0L13.126 23.734a.784.784 0 0 0 0 1.124Z",
  fill: "#2D91FF"
})));
export default SvgIconCoupon38X38;